// require module

var dojoContextRequire = window.require.bind(null);
dojoContextRequire.toUrl = window.require.toUrl;
dojoContextRequire.toAbsMid = window.require.toAbsMid;
dojoContextRequire.isXdUrl = window.require.isXdUrl;
dojoContextRequire.syncLoadNls = function syncLoadNls() {
  return undefined;
};
module.exports = dojoContextRequire;